<template>
  <div>
    <b-card>
      <div class="text-right mb-3">
        <router-link
          class="btn btn-primary"
          :to="{ name: 'Bestoftypes.create' }"
        >
          <i class="fa fa-plus"></i> Criar
        </router-link>
      </div>

      <Grid
        ref="campaignTypesGrid"
        name="bestoftypesGrid"
        v-bind:url="url"
        v-bind:preload="preload"
        v-bind:columns="columns"
        :pageable="true"
        :filterable="true"
        :sortable="true"
        v-bind:schemaModelFields="schemaModelFields"
        :schema="schema"
        :serverPaging="true"
        :serverFiltering="true"
        :serverSorting="true"
      ></Grid>
    </b-card>
  </div>
</template>

<script>
import Grid from "@/components/Grid.vue";
import router from "@/router";

export default {
  name: "bestoftypesGrid",
  components: {
    Grid,
  },
  data() {
    return {
      schema: {
        data: "data",
        total: "meta.pagination.total",
      },
      schemaModelFields: {
        created_at: { type: "date" },
        updated_at: {
          type: "date",
        },
        state: { type: "string" },
        date_start: { type: "string" },
        date_end: { type: "string" },
      },
      url: "bestof/campaign-types",

      columns: [
        {
          template: this.getBtnTemplate,
          title: "",
          width: "100px",
        },
        {
          field: "id",
          title: "Id",
          width: "80px",
        },
        {
          field: "code",
          title: "Código",
          width: "220px",
          headerAttributes: { title: "Código" },
        },
        {
          field: "name",
          title: "Nome",
          width: "220px",
          headerAttributes: { title: "Nome" },
        },
        {
          field: "leaders",
          title: "Campanha de líderes",
          width: "120px",
          headerAttributes: { title: "Campanha de líderes" },
          template: function(dataItem) {
            return dataItem.leaders == 1 ? "Sim" : "Não";
          },
          filterable: {
            ui: function(element) {
              element.kendoDropDownList({
                dataSource: [
                  { text: "Sim", value: 1 },
                  { text: "Não", value: 0 }
                ],
                dataTextField: "text",
                dataValueField: "value",
                optionLabel: "Select..."
              });
            }
          }
        },
        {
          field: "points",
          title: "Atribui pontos",
          width: "120px",
          headerAttributes: { title: "Atribui pontos" },
          template: function(dataItem) {
            return dataItem.points == 1 ? "Sim" : "Não";
          },
          filterable: {
            ui: function(element) {
              element.kendoDropDownList({
                dataSource: [
                  { text: "Sim", value: 1 },
                  { text: "Não", value: 0 }
                ],
                dataTextField: "text",
                dataValueField: "value",
                optionLabel: "Select..."
              });
            }
          }
        },
        {
          field: "date_start",
          title: "Ínicio",
          width: "120px",
          headerAttributes: { title: "Ínicio" },
        },
        {
          field: "date_end",
          title: "Fim",
          width: "120px",
          headerAttributes: { title: "Fim" },
        },
        //
        // 🔥 UPDATED COLUMN — now shows "Enable"/"Disable"
        //
        {
          field: "state",
          title: "Estado",
          width: "120px",
          headerAttributes: { title: "Estado" },
          template: "#= state #", // mostra exatamente "Enable" ou "Disable"
          filterable: {
            ui: function(element) {
              element.kendoDropDownList({
                dataSource: [
                  { text: "Enable", value: "Enable" },
                  { text: "Disable", value: "Disable" }
                ],
                dataTextField: "text",
                dataValueField: "value",
                optionLabel: "Select..."
              });
            }
          }
        },
        {
          field: "created_at",
          title: "Criado em",
          format: "{0:dd/MM/yyyy HH:mm}",
          type: "date",
          width: "180px",
          filterable: {
            ui: function (element) {
              element.kendoDateTimePicker({
                format: "dd/MM/yyyy HH:mm",
              });
            },
          },
        },
        {
          field: "updated_at",
          title: "Atualizado em",
          format: "{0:dd/MM/yyyy HH:mm}",
          type: "date",
          width: "180px",
          filterable: {
            ui: function (element) {
              element.kendoDateTimePicker({
                format: "dd/MM/yyyy HH:mm",
              });
            },
          },
        },
      ],
    };
  },

  methods: {
    getBtnTemplate(item) {
      const route = router.resolve({
        name: "Bestoftypes.edit",
        params: { id: item.id },
      });

      if (this.$auth.check("Bestoftypes.edit")) {
        return (
          '<a href="' +
          route.href +
          '" class="btn btn-primary"><i class="fa fa-pencil"></i> editar</a>'
        );
      }
      return "";
    },

    exportGrid() {
      this.exporting = true;
      const grid = this.$refs.campaignsGeneralGrid.$refs.mygrid.kendoWidget();
      const filters = grid.getOptions().dataSource.filter;

      this.axios
        .post("campaignsgeneral/exportgeneralcampaigns", { filter: filters })
        .then((response) => {
          if (response.data && response.data.url) {
            window.open(response.data.url, "_blank");
          } else {
            this.$bvToast.toast("Falha ao gerar o arquivo.", {
              variant: "danger",
              solid: true,
            });
          }
          this.exporting = false;
        })
        .catch((error) => {
          console.error(error);
          this.$bvToast.toast("Houve um erro ao exportar", {
            autoHideDelay: 5000,
            variant: "danger",
            solid: true,
          });
          this.exporting = false;
        });
    },
  },
};
</script>
